<template>
    <main-content-wrapper>
        <h1>Sprememba prejema e-novic</h1>
        <div class="loader" v-if="loading">
            <empty-space />
            <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
        </div>
        <template v-if="error">
            <v-alert
                    :value="true"
                    type="error"
            >
                Pri pridobivanju vaših podatkov je prišlo do napake. Koda napake: {{ error_code }}.
            </v-alert>
        </template>
        <template v-if="!loading && email">
            <template v-if="!saved">
                <div class="foreword">
                    Spoštujemo vašo zasebnost in željo, da ne želite več prejemati naših e-novic na naslov <span class="email">{{ email }}</span> v takšni obliki kot do sedaj.
                    <empty-space />
                    <b>Ali se želite odjaviti od prejemanje vseh e-novic?</b>
                </div>
                <empty-space />
                <unsubscribe-settings v-on:saved="onSaved" v-on:error="onError" :user_key="user_key" ></unsubscribe-settings>
            </template>
            <div v-if="saved" class="text-sm-center">
                Vaše spremembe so bile uspešno shranjene!
                <empty-space />
                <v-btn depressed large block color="primary_action" @click="goTo" :loading="loading">Nadaljuj</v-btn>
            </div>
        </template>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import UnsubscribeSettings from "../components/UnsubscribeSettings";
    import EmptySpace from "../components/EmptySpace";
    import utils from "../store/utils";

    export default {
        name: "UnsubscribeEmail",
        components: {UnsubscribeSettings, MainContentWrapper, EmptySpace},
        data: vm => ({
            saved: false,
            user_key: undefined
        }),
        computed: {
            loading: utils.vuexBuildSetGet(this, 'profile', 'loading'),
            email: utils.vuexBuildSetGet(this, 'profile', 'user.personal.eMail'),
            error: utils.vuexBuildSetGet(this, 'profile', 'error'),
            error_code: utils.vuexBuildSetGet(this, 'profile', 'error_code'),
            authenticated: utils.vuexBuildSetGet(this, null, 'auth.authenticated')
        },
        created() {
            if (this.$route.params['user_key']) {
                this.user_key = this.$route.params['user_key'];
                this.$store.dispatch('profile/allAboutMe', {'user_key': this.user_key});
            } else if (this.authenticated){
                this.$store.dispatch('profile/allAboutMe');
            } else {
                window.location.replace('/');
            }
        },
        watch: {
            loading: function (val) {
                if (this.email == undefined){
                    window.location.replace('/');
                }
            }
        },
        mounted() {
            this.$trackPageVisit('email-unsubscribe');
        },
        methods: {
            onSaved(){
                this.saved = true;
            },
            onError(error){
                console.log(error)
            },
            goTo(){
                window.location.replace('/');
            }
        }
    }
</script>

<style scoped>

    .loader {
        text-align: center;
    }

    .foreword {
        font-size: 1.2em;
        text-align: justify;
    }

    .email{
        font-weight: bold;
        color: #22753a;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>